/**
 * ProductHero — kompakte Hero-Karte der Produktdetailseite.
 * Bild + Kopfzeile (Badges/Meta/Aktionen) + Titel + Kennungen + Kennzahlen.
 * Max 100 lines.
 */

import type { Product } from '@/types/products';
import { ProductHeroImage } from './ProductHeroImage';
import { ProductHeroTopBar } from './ProductHeroTopBar';
import { ProductHeroIdentifiers } from './ProductHeroIdentifiers';
import { ProductHeroMetrics } from './ProductHeroMetrics';

interface ProductHeroProps {
  product: Product;
  firstImageUrl: string | null;
  imageCount: number;
  isSyncing: boolean;
  onSync: () => void;
  onManageImages: () => void;
}

export function ProductHero({
  product,
  firstImageUrl,
  imageCount,
  isSyncing,
  onSync,
  onManageImages,
}: ProductHeroProps) {
  return (
    <article className="product-hero bg-white dark:bg-neutral-900 rounded-2xl border border-neutral-200 dark:border-neutral-800 p-5 sm:p-6">
      <div className="flex gap-5">
        <ProductHeroImage
          imageUrl={firstImageUrl}
          imageCount={imageCount}
          onManageImages={onManageImages}
        />

        <div className="flex-1 min-w-0 flex flex-col gap-3">
          <ProductHeroTopBar product={product} isSyncing={isSyncing} onSync={onSync} />
          <h1 className="text-xl sm:text-2xl font-bold text-neutral-900 dark:text-neutral-50 leading-tight">
            {product.name}
          </h1>
          <ProductHeroIdentifiers product={product} />
          <ProductHeroMetrics product={product} />
        </div>
      </div>
    </article>
  );
}
